$(() => {
    $(document).on('click', '.toggle-customer-support', function (e) {
        e.stopImmediatePropagation();

        var classname = 'target-opened';
        var $target = $('#' + $(this).attr('data-reveal-target'));

        $(this).toggleClass(classname);

        $target.toggle();
    });
});
